import Navbar from "./Navbar";
import "../index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { TodoContext } from "./Todo_Context";
import { useContext } from "react";
function Home() {
  const {
    addTodo,
    handleInputChange,
    currentTodo,
    editTodo,
    toggleComplete,
    todos,
    Bold_text,
    italic_text,
    handleDelete,
    TogglesColros,
    showColors,
    Color,
    Text_Color,
  } = useContext(TodoContext);

  return (
    <div className="App">
      <Navbar />

      <div className="d-flex justify-content-between p-1 bg-light text-styles">
        <input
          type="text"
          value={currentTodo}
          onChange={handleInputChange}
          placeholder="Enter a todo"
          className={`form-control w-75 ms-2`}
        />
        <button onClick={addTodo} className="btn btn-success">
          Add Todo
        </button>
      </div>

      {/* ------------------------------------------------------------------------------------------ */}

      {todos.length === 0 ? (
        <p className="text-success fw-bold fs-3 text-center">
          your todo list is empty
        </p>
      ) : (
        todos.map((todo, index) => (
          <div key={todo.id} className="p-1 bg-light text-styles card-text">
            <div className="div_text">
              <input
                type="checkbox"
                checked={todo.completed}
                onChange={() => toggleComplete(index)}
                className="m-2"
              />
              {todo.completed ? (
                <del
                  className={`${todo.isBold ? "bold" : ""} ${
                    todo.isItalic ? "italic" : ""
                  }`}                >
                  {todo.text}
                </del>
              ) : (
                <span
                  className={`${todo.isBold ? "bold" : ""} ${
                    todo.isItalic ? "italic" : ""
                  }`}
                  style={{color:Color}}

                >
                  {todo.text}
                </span>
              )}
            </div>
            <div className="btn_notes">
              <button
                className="btn btn-danger m-1"
                onClick={() => handleDelete(todo.id)}
              >
                Delete
              </button>
              <button
                className="btn btn-secondary m-1"
                onClick={() => {
                  const newText = prompt("Enter new text", todo.text);

                  if (newText) {
                    editTodo(index, newText);
                  }
                }}
              >
                Edit
              </button>
              <button
                className="btn btn-secondary fs-6 m-1"
                onClick={() => Bold_text(todo.id)}
              >
                <i className="bi bi-type-bold"></i>
              </button>

              <button
                className="btn btn-secondary fs-6 m-1"
                onClick={() => italic_text(todo.id)}
              >
                <i className="bi bi-type-italic"></i>
              </button>
              <button
                className="btn btn-secondary fs-6 m-1"
                onClick={TogglesColros}
              >
                <i className="bi bi-palette"></i>
              </button>

              <div className={`${showColors ? "" : "colors"}`}>
                <div className="c_black" onClick={()=>Text_Color('black')}></div>
                <div className="c_green" onClick={()=>Text_Color('green')}></div>
                <div className="c_pink" onClick={()=>Text_Color('pink')}></div>
                <div className="c_red" onClick={()=>Text_Color('red')}></div>
                <div className="c_blue" onClick={()=>Text_Color('blue')}></div>
                <div className="c_orange" onClick={()=>Text_Color('orange')}></div>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default Home;
